import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { actions as rtSagaAction } from "../redux/receiptTrackingSaga";
import { actions as rtReducerActions } from "../redux/receiptTrackingSlice";
import { refSagaActions } from "../../Administration/ReferenceInfoManagement";

import DataTable from "react-data-table-component";
import { format, parseISO } from "date-fns";
import { Button, Spinner, Alert, Fade } from "react-bootstrap";

import { ReceiptTrackingSearchForm } from "./ReceiptTrackingSearchForm";
import { ReceiptDetails } from "./ReceiptDetails";

const XLSX = require('xlsx');

const date = Date().split(" ");
const dateStr = date[2] + date[1] + date[3];

const presentDate = new Date();
const formatPresentDate = format(presentDate, "dd/MM/yyyy");

const moneyFormater = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "PGK"
});

// Blatant "inspiration" from https://codepen.io/Jacqueline34/pen/pyVoWr
function convertArrayOfObjectsToCSV(array) {
  let result;

  const columnDelimiter = ",";
  const lineDelimiter = "\n";
  let keys = Object.keys(array[0].latestAudit);
  //convert keys to formatted named table column names
  keys = keys.map((k) => {
    let key = {};
    key.value = k;
    key.name = k.replaceAll("_", " ");
    key.name = key.name.split(' ').map(str => (
      str.charAt(0).toUpperCase() + str.slice(1)
    )).join(' ');
    
    return key;
  })
  
  result = "";
  result += keys.map(k => k.name).join(columnDelimiter);
  result += lineDelimiter;
  
  array.forEach((item) => {
    
    let ctr = 0;
    keys.forEach((key) => {
      if (ctr > 0) result += columnDelimiter;

      result += item.latestAudit[key.value];

      ctr++;
    });

    if(item.oldAuditList.length > 0){
      
      item.oldAuditList.forEach(rcpt => {

        result += lineDelimiter;

        keys.forEach((key) => {

          result += rcpt[key.value];

          result += columnDelimiter;
    
          ctr++;
        });
        
      });
      
    }

    result += lineDelimiter;
  });
  
  return result;
};

// Blatant "inspiration" from https://codepen.io/Jacqueline34/pen/pyVoWr
function downloadCSV(array) {
  if(array.length === 0){
    return
  }
  const link = document.createElement("a");
  let csv = convertArrayOfObjectsToCSV(array);
  if (csv == null) return;

  const filename = `Receipt Tracking Report_${dateStr}.csv`;

  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${csv}`;
  }
  // link.setAttribute("href", atob(csv));
  link.setAttribute("href", encodeURI(csv));
  link.setAttribute("download", filename);
  link.click();
};

function downloadEXCEL(array) {
  if(array.length === 0){
    return
  }

  let data = [];
  
  array.forEach((rcptObj) => {
    data.push(rcptObj.latestAudit);
    if(rcptObj.oldAuditList.length > 0){
      rcptObj.oldAuditList.forEach(auditRcpt => {
        data.push(auditRcpt);
      });
    }
  });

  let worksheet = XLSX.utils.json_to_sheet(data);
  var workBook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workBook, worksheet, `Receipt Tracking ${dateStr}`);

  XLSX.writeFile(workBook, `Receipt Tracking ${dateStr}.xlsx`);
};

function downloadPDFReport(dataStr){
  if (!dataStr || dataStr.length === 0){
    alert("PDF file was not generated.");
    return;
  }
  const filename = `Receipt Tracking Report_${dateStr}.pdf`;
  const link = document.createElement("a");
  let data = 'data:application/pdf;base64,' + dataStr;
  link.setAttribute("href", data);
  link.setAttribute("download", filename);
  link.click();
};

const sortReportParams = (queryParams) => {
  let parameters = [
    {
      paramName: "p_receiptNumber",
      paramValue: queryParams.receiptNumber,
      paramDataType: "java.lang.String"
    },
    {
      paramName: "p_mobileNumber",
      paramValue: queryParams.mobileNumber,
      paramDataType: "java.lang.String"
    },
    {
      paramName: "p_departmentId",
      paramValue: queryParams.departmentId,
      paramDataType: "java.lang.Integer"
    },
    {
      paramName: "p_provinceId",
      paramValue: queryParams.provinceId,
      paramDataType: "java.lang.Integer"
    },
    {
      paramName: "p_customerFirstName",
      paramValue: queryParams.customerFirstName,
      paramDataType: "java.lang.String"
    },
    {
      paramName: "p_customerLastName",
      paramValue: queryParams.customerLastName,
      paramDataType: "java.lang.String"
    },
    {
      paramName: "p_serviceTypeId",
      paramValue: queryParams.serviceId,
      paramDataType: "java.lang.Integer"
    },
    {
      paramName: "p_serviceItemId",
      paramValue: queryParams.serviceItemId,
      paramDataType: "java.lang.Integer"
    },
    {
      paramName: "p_fromDate",
      paramValue: queryParams.fromIssuedDate,
      paramDataType: "java.sql.Date"
    },
    {
      paramName: "p_toDate",
      paramValue: queryParams.toIssuedDate,
      paramDataType: "java.sql.Date"
    },
    {
      paramName: "p_receiptStatusId",
      paramValue: queryParams.receiptStatusId,
      paramDataType: "java.lang.Integer"
    }
  ];

  parameters = parameters.filter((param) => param.paramValue !== "" && param.paramValue !== null && param.paramValue !== undefined );
  
  return parameters;
};

const Export = ({ onCSVExport, onPDFExport, onExcelExport, pdfReportLoading }) => (
  <>
    <Button variant="primary" onClick={(e) => onCSVExport(e.target.value)} style={{fontSize: "14px"}}>CSV</Button>{" "}
    <Button variant="primary" onClick={(e) => onPDFExport(e.target.value)} disabled={pdfReportLoading} style={{fontSize: "14px"}}>PDF</Button>{" "}
    <Button variant="primary" onClick={(e) => onExcelExport(e.target.value)} style={{fontSize: "14px"}}>EXCEL</Button>
  </>
);

const columns = [
  {
    name: "Receipt No.",
    selector: (row) => row.latestAudit.rcpt_number,
    sortable: true,
  },
  {
    name: "Status",
    selector: (row) => row.latestAudit.rcpt_status_desc,
    sortable: true,
  },
  {
    name: "Customer",
    selector: (row) => row.latestAudit.cust_first_name + " " + row.latestAudit.cust_last_name,
    sortable: true,
  },
  {
    name: "Mobile No.",
    selector: (row) => row.latestAudit.cust_msisdn,
    sortable: true,
  },
  {
    name: "Service Item",
    selector: (row) => row.latestAudit.service_item_desc,
    sortable: true,
  },
  {
    name: "Price",
    selector: (row) => moneyFormater.format(row.latestAudit.total_amnt),
    sortable: true,
  },
  {
    name: "Department",
    selector: (row) => row.latestAudit.dept_name,
    sortable: true,
  },
  {
    name: "Province",
    selector: (row) => row.latestAudit.province_name,
    sortable: true,
  },
  {
    name: "Date",
    selector: (row) => format(parseISO(row.latestAudit.audit_datetime),"dd-MMM-yyyy"),
    sortable: true,
  },
];

const dataTableStyles = {
  rows: {
    style: {
      fontSize: "15px"
    },
  },
  headCells: {
    style: {
      fontSize: "16px"
    },
  },
  cells: {
    style: {
      fontSize: "15px"
    },
  },
  pagination: {
    style: {
      fontSize: "16px"
    }
  }
};


export function ReceiptsTable() {

  const dispatch = useDispatch();

  const { receiptTracking } = useSelector(state => state);
  const data = receiptTracking.sortedReceipts;
  
  const { listLoading, pdfReceiptReportStr:reportStr, pdfReportLoading, receiptsMaxLimit, receiptMaxErrorMsg } = receiptTracking;

  const [ showRcptLimitErr, setShowRcptLimitErr ] = useState(false);
  
  const actionsMemo = useMemo(() => 
    <Export 
      onPDFExport={() => downloadPDFReport(reportStr)} 
      onCSVExport={() => downloadCSV(data)} 
      onExcelExport={() => downloadEXCEL(data)}
      pdfReportLoading={pdfReportLoading} 
    />,
  [data, reportStr, pdfReportLoading]);

  useEffect(() => {
    dispatch(rtReducerActions.clearReportString());
    dispatch(rtSagaAction.fetchReceipts({ 
      fromIssuedDate: formatPresentDate,
      toIssuedDate: formatPresentDate
    }));
    dispatch(refSagaActions.fetchReferenceKinds());
  },[dispatch]);

  useEffect(() => {
    if(receiptsMaxLimit){
      setShowRcptLimitErr(true);
      setTimeout(() => {
        dispatch(rtReducerActions.clearReceiptMaxLimit());
        setShowRcptLimitErr(false);
      }, 8000);
    } else {
      setShowRcptLimitErr(false);
    }
  }, [receiptsMaxLimit, dispatch, receiptMaxErrorMsg]);

  const closeAlert = () => {
    dispatch(rtReducerActions.clearReceiptMaxLimit());
    setShowRcptLimitErr(false);
  };

  const handleSearchReceipt = (queryParams) => {
    dispatch(rtReducerActions.clearReportString());
    searchReceipts(queryParams);
    handlePDFReport(queryParams);
  };

  const searchReceipts = (queryParams) => {

    dispatch(rtSagaAction.findReceipts(queryParams));
  };

  const handleReset = (queryParams) => {

    searchReceipts(queryParams);
    dispatch(rtSagaAction.clearReportString());
  };

  const handlePDFReport = (queryParams) => {
    
    getJasperPDFReport(queryParams);
  };

  const getJasperPDFReport = (queryParams) => {
    let definedParams = sortReportParams(queryParams);

    let reportQueryParams = {
      reportFileNameWithExt: "receipt-tracking-report.jrxml",
      parameters: definedParams,
      generatedFileName: `Receipt Tracking Report ${dateStr}`,
      reportOutputTypeCode: "PDF",
      saveFile: true
    };

    dispatch(rtSagaAction.receiptsPDFReport(reportQueryParams));
  };

  return (
    <div className="card card-custom card-stretch gutter-b">
      {/* begin::Header */}

      {/* end::Header */}

      {/* begin::Body */}

      {
        showRcptLimitErr ?
        <div className="d-flex justify-content-end">
          <Alert variant="info" transition={Fade} onClose={closeAlert} dismissible style={{ width: "50%", zIndex: 2, position: "absolute" }} >
            <Alert.Heading > Maximum Receipt Records Reached </Alert.Heading>
            <p>
              <b> {receiptMaxErrorMsg} </b>
              <br/>
              Adjust your search parameters to make a narrow or specific search for receipt records.
            </p>
          </Alert>
        </div>
        : null  
      }
      
      <div className="card-body py-6">
        <div className="row justify-content-start">
          <div className="col-12">
            <ReceiptTrackingSearchForm 
              onHandleSearchReceipt={handleSearchReceipt}
              onHandleFormReset={handleReset}
              resultsLoading={listLoading}
              pdfStrLoading={pdfReportLoading} 
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">

            {/* begin::Table */}
            <DataTable
              title={<h4>Receipts</h4>}
              customStyles={dataTableStyles}
              columns={columns}
              data={data}
              actions={actionsMemo}
              progressPending={ listLoading === false && pdfReportLoading === false ? false : true }
              expandableRows
              highlightOnHover
              pointerOnHover
              expandableRowsComponent={ReceiptDetails}
              expandOnRowClicked
              progressComponent={<Spinner animation="border" variant="primary" size="lg" />}
              pagination
            />
            {/* end::Table */}
          </div>
        </div>
      </div>
      {/* end::Body */}
    </div>
  );
}
